"use strict";
/**
 * @author Maxim Seredkin
 */
export default [
  "$resource",
  function ($resource) {
    return $resource("api/investactivity/:investactivityId", null, {
      getAll: { url: "api/investactivity", method: "GET" },
      get: { method: "GET" },
      create: { url: "api/investactivity", method: "POST" },
      update: { method: "PUT" },
      remove: { method: "DELETE" },
    });
  },
];
